import React from 'react';
import { useTranslation } from 'react-i18next';
import NotificationItem from './NotificationItem';
import './NotificationList.css';

/**
 * NotificationList Component
 * Renders a list of notifications
 */
function NotificationList({ notifications, onNotificationClick }) {
  const { t } = useTranslation('notifications');

  if (!notifications || notifications.length === 0) {
    return (
      <div className="notification-list-empty">
        <p>{t('notifications.empty', 'No notifications')}</p>
      </div>
    );
  }

  return (
    <ul className="notification-list">
      {notifications.map((notification) => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          onClick={onNotificationClick}
        />
      ))}
    </ul>
  );
}

export default NotificationList;
